// 💾 src/pages/client/sections/components/Portfolio/Sidebar.tsx
import {
  FaWallet, FaExchangeAlt, FaRobot, FaHistory
} from "react-icons/fa"
import {
  BiBot, BiTrendingUp
} from "react-icons/bi"
import { RiBankCardFill, RiPulseFill } from "react-icons/ri"
import { AiFillGift } from "react-icons/ai"
import "./style/Sidebar.scss"

type Props = {
  activeTab: string
  setActiveTab: (key: string) => void
}

const Sidebar = ({ activeTab, setActiveTab }: Props) => {
  return (
    <aside className="sidebar">
      <div className="nav-group">
        <div className="group-title">Overview</div>
        <div
          className={`sidebar-item ${activeTab === "overview" ? "active" : ""}`}
          onClick={() => setActiveTab("overview")}
        >
          <FaWallet />
          Overview
        </div>
      </div>

      <div className="nav-group">
        <div className="group-title">Markets</div>
        <div
          className={`sidebar-item ${activeTab === "spot" ? "active" : ""}`}
          onClick={() => setActiveTab("spot")}
        >
          <BiTrendingUp />
          Spot 
        </div>
        <div
          className={`sidebar-item ${activeTab === "dex" ? "active" : ""}`}
          onClick={() => setActiveTab("dex")}
        >
          <FaExchangeAlt />
          DEX+
        </div>
        <div
          className={`sidebar-item ${activeTab === "futures" ? "active" : ""}`}
          onClick={() => setActiveTab("futures")}
        >
          <RiPulseFill />
          Futures 
        </div>
      </div>

      <div className="nav-group">
        <div className="group-title">Tools</div>
        <div className={`sidebar-item ${activeTab === "fiat" ? "active" : ""}`} onClick={() => setActiveTab("fiat")}>
          <RiBankCardFill />
          Fiat
        </div>
        <div className={`sidebar-item ${activeTab === "copy" ? "active" : ""}`} onClick={() => setActiveTab("copy")}>
          <BiBot />
          Copy Trade
        </div>
        <div className={`sidebar-item ${activeTab === "bot" ? "active" : ""}`} onClick={() => setActiveTab("bot")}>
          <FaRobot />
          Trading Bot
        </div>
        <div className={`sidebar-item ${activeTab === "alpha" ? "active" : ""}`} onClick={() => setActiveTab("alpha")}>
          <AiFillGift />
          Alpha
        </div>
        <div className={`sidebar-item ${activeTab === "history" ? "active" : ""}`} onClick={() => setActiveTab("history")}>
          <FaHistory />
          Funding History
        </div>
      </div>

      <div className="sidebar-footer">Crypto Platform © 2025</div>
    </aside>
  )
}

export default Sidebar
